<div class="custom-select-wrapper"
     [class.focused]="isFocused"
     [class.has-value]="hasValue"
     [class.disabled]="disabled">
  <div class="custom-select-container" (click)="openModal(selectModal)">
    <div class="custom-select-input" [ngClass]="inputClass">
      <span class="selected-value" *ngIf="hasValue">{{ displayValue }}</span>
      <img
        src="assets/icons/icon-select.svg"
        class="select-icon"
        [attr.alt]="'alt.openSelect' | translate"
      />
    </div>
    <label
      *ngIf="label"
      class="floating-label"
      [class.floating]="isFocused || hasValue"
    >
      <img
        src="assets/icons/required-asterisk.svg"
        *ngIf="required"
        [attr.alt]="'alt.requiredField' | translate"
      >
      {{ label }}
    </label>
  </div>
</div>

<ng-template #selectModal let-modal>
  <div class="custom-select-modal-container">
    <div class="modal-drag-line" 
         (touchstart)="onTouchStart($event)" 
         (touchmove)="onTouchMove($event)" 
         (touchend)="onTouchEnd($event, modal)">
      <img
        src="assets/icons/icon-line-select.svg"
        [attr.alt]="'alt.dragHandle' | translate"
      />
    </div>
    <div class="modal-header">
      <h5 class="modal-title">{{ label }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
        <img
          src="assets/icons/icon-close-select.svg"
          [attr.alt]="'alt.close' | translate"
        />
      </button>
    </div>
    <div class="modal-body">
      <div class="search-container">
        <div class="search-input-wrapper">
          <img
            src="assets/icons/icon-search-gray.svg"
            class="search-icon"
            [attr.alt]="'alt.search' | translate"
          />
          <input
            type="text"
            class="search-input"
            placeholder="Поиск..."
            [(ngModel)]="searchTerm"
            (input)="onSearchInput()"
          />
        </div>
      </div>
      <div class="options-list" (scroll)="onListScroll($event)">
        <div
          *ngFor="let option of filteredOptions; trackBy: trackByOption"
          class="option-item"
          [class.selected]="option[valueKey] === value"
          (click)="selectOption(option, modal)"
        >
          <span>{{ getOptionDisplayText(option) }}</span>
          <img
            *ngIf="option[valueKey] === value"
            src="assets/icons/check.svg"
            class="check-icon"
            [attr.alt]="'alt.optionSelected' | translate"
          />
        </div>
        <div *ngIf="filteredOptions.length === 0" class="no-options">
          Ничего не найдено
        </div>
      </div>
    </div>
  </div>
</ng-template>

